﻿import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import styles from "./settings-section.module.scss";

const SettingsSection = ({ title, subtitle, cards }) => {
	const navigate = useNavigate();

	if (!cards || cards.length === 0) return null;

	return (
		<section className={styles.section}>
			<div className={styles.header}>
				<h1 className={styles.title}>{title}</h1>
				<p className={styles.subtitle}>{subtitle}</p>
			</div>

			<div className={styles.cardsGrid}>
				{cards.map((card) => (
					<button key={card.key} className={styles.card} onClick={() => navigate(card.to)} type="button">
						<div className={styles.cardIconWrapper}>
							<card.Icon size={24} strokeWidth={2} />
						</div>
						<h3 className={styles.cardTitle}>{card.title}</h3>
						<p className={styles.cardDescription}>{card.description}</p>
						{card.count !== undefined && card.count !== null && <span className={styles.cardBadge}>{card.count} registros</span>}
						<ChevronRight className={styles.cardArrow} size={20} />
					</button>
				))}
			</div>
		</section>
	);
};

export default SettingsSection;
